export default __webpack_public_path__ + "static/media/m_bubble_bg.a0a52e2f.png";